// The Customer Portal Mixpanel project (DATA-1497, project id 4033650). Client
// write tokens are not secrets, so this ships to the browser.
//
// Only the prod host sends to Mixpanel. Other envs log events to the console so
// we can verify event shape without polluting the single beta project (there is
// no separate nonprod/test project). Unknown hosts stay off.
const PORTAL_PROJECT_TOKEN = '2655c50c2a577a3ed1dbdba074b0c6ed'

export type AnalyticsMode =
  | { kind: 'mixpanel'; token: string }
  | { kind: 'console' }
  | { kind: 'off' }

// Exact host or a subdomain of it, so `evilhelpscoutportal.com` doesn't match
// `helpscoutportal.com`.
const matchesHost = (hostname: string, apex: string): boolean =>
  hostname === apex || hostname.endsWith(`.${apex}`)

export const resolveAnalyticsMode = (
  hostname: string = window.location.hostname
): AnalyticsMode => {
  if (matchesHost(hostname, 'helpscoutportal.com')) {
    return { kind: 'mixpanel', token: PORTAL_PROJECT_TOKEN }
  }
  if (
    matchesHost(hostname, 'portal-np.superscout.net') ||
    matchesHost(hostname, 'portal.local.hsenv.io')
  ) {
    return { kind: 'console' }
  }
  return { kind: 'off' }
}
